export const NOTIFICATION_STORAGE_KEY = 'roadassist_notifications';
